






































import _ from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import CouponPage from '@spa/components/pages/mypage/coupon/models/coupon-page'
import CouponListItem from './CouponListItem.vue'
import CouponPagination from './CouponPagination.vue'

@Component({
  components: {
    CouponListItem,
    CouponPagination,
  },
})
export default class CouponList extends Vue {
  @Prop({ required: true })
  couponPage: CouponPage

  @Prop({ required: true })
  hasNextPage: boolean

  @Emit()
  onNewPageSelected(_pageNumber: number) {
    this.scrollToTop()
  }

  /**
   * FIXME: There are similar copy-paste codes.
   */
  scrollToTop() {
    const scrolled = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop

    // tslint:disable-next-line
    window.scrollTo(0, Math.floor(scrolled / 2))
    if (scrolled > 0) {
      // tslint:disable-next-line
      window.setTimeout(this.scrollToTop, 30);
    }
  }
}
